module.exports = __webpack_public_path__ + "static/media/wordpress.fcf803f1.svg";